var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceSolid16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice-solid-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C1.44772 1 1 1.44771 1 2V15C1 15.2761 1.22386 15.5 1.5 15.5H2.08579C2.351 15.5 2.60536 15.3946 2.79289 15.2071L3.29289 14.7071C3.68342 14.3166 4.31658 14.3166 4.70711 14.7071L5.29289 15.2929C5.68342 15.6834 6.31658 15.6834 6.70711 15.2929L7.29289 14.7071C7.68342 14.3166 8.31658 14.3166 8.70711 14.7071L9.29289 15.2929C9.68342 15.6834 10.3166 15.6834 10.7071 15.2929L11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L13.2071 15.2071C13.3946 15.3946 13.649 15.5 13.9142 15.5H14.5C14.7761 15.5 15 15.2761 15 15V2C15 1.44772 14.5523 1 14 1H2ZM4 4.75C4 4.33579 4.33579 4 4.75 4H11.25C11.6642 4 12 4.33579 12 4.75C12 5.16421 11.6642 5.5 11.25 5.5H4.75C4.33579 5.5 4 5.16421 4 4.75ZM4 7.75C4 7.33579 4.33579 7 4.75 7H8.25C8.66421 7 9 7.33579 9 7.75C9 8.16421 8.66421 8.5 8.25 8.5H4.75C4.33579 8.5 4 8.16421 4 7.75Z",
    fill: "#7B868C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceSolid16);
export default __webpack_public_path__ + "static/media/invoice_solid_16.4da1cc29742c95d396932e0efea20ef4.svg";
export { ForwardRef as ReactComponent };